import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CategoryDocumentList from './CategoryDocumentList';
import CategoryDocumentForm from './CategoryDocumentForm';

const CategoryDocumentRoutes = () => {
  return (
    <Routes>
      <Route index element={<CategoryDocumentList />} />
      <Route path="new" element={<CategoryDocumentForm />} />
      <Route path="edit/:id" element={<CategoryDocumentForm />} />
    </Routes>
  );
};

export default CategoryDocumentRoutes; 